/* eslint-disable max-len */
/* eslint-disable no-bitwise */
import symbols from "@/assets/images/ActivitiesIcons/syncfusion/symbols";
import { createPorts, getAutostartShape, ports } from "@/pages/main/views/Syncfusion/DiagramFunctions";
import {
    DiagramTools,
    AnnotationConstraints,
    NodeConstraints,
    // ConnectorConstraints,
    DiagramConstraints
} from "@syncfusion/ej2-vue-diagrams";
import shortId from "short-uuid";

const snapDistance = 8;
// grid config
const gridlines = {
    lineColor: "#E2E6EB",
    lineIntervals: [0.5, 7.5, 0.15, 7.85, 0.15, 7.85, 0.15, 7.85, 0.15, 7.85, 0.15, 7.85, 0.15, 7.85, 0.15, 7.85],
    snapIntervals: [snapDistance]
};

const snapSettings = {
    horizontalGridlines: gridlines,
    verticalGridlines: gridlines,
    gridType: "Lines"
};

export const annotationConfig = {
    verticalAlignment: "Top",
    horizontalAlignment: "Center",
    style: {
        color: "#196A84",
        fontFamily: "Roboto",
        fontSize: 10,
        fill: "#F3F5F7"
    },
    displacement: {
        x: 0,
        y: 10
    }
};

// inside diagram
export function getNodeDefaults(node) {
    let source;
    const { additionalOptions: { hasRecurrence } = {} } = node.addInfo || {};
    if (hasRecurrence !== undefined) {
        source = getAutostartShape(hasRecurrence);
    } else {
        source = symbols[node.data.typeId];
    }
    node.width = 64;
    node.height = 64;
    node.shape = {
        type: "Image",
        source,
        scale: "Meet"
    };
    node.style = {
        fill: "none",
        strokeWidth: 1.5,
        strokeColor: "none"
    };
    node.ports = createPorts();
    node.constraints = NodeConstraints.PointerEvents | NodeConstraints.Select | NodeConstraints.HideThumbs | NodeConstraints.OutConnect | NodeConstraints.InConnect;
}

export const diagramConfig = {
    nodes: [],
    connectors: [],
    snapSettings,
    width: "100%",
    height: "100%",
    mode: "SVG",
    serializationSettings: { preventDefaults: true },
    tool: ~DiagramTools.MultipleSelect,
    constraints: DiagramConstraints.Default | DiagramConstraints.Bridging,
    scrollSettings: {
        currentZoom: 1,
        minZoom: 0.1,
        maxZoom: 3,
        canAutoScroll: false,
        scrollLimit: "Infinity"
    },
    commandManager: {
        commands:
        [
            {
                name: "copy",
                canExecute() {
                    return false;
                }
            }
        ]
    }
};

const positions = {
    onTrack: "TOP_LEFT",
    attention: "TOP_RIGHT",
    atRisk: "BOTTOM_LEFT",
    overdue: "BOTTOM_RIGHT",
    total: "CENTER_CENTER"
};

function createAnchoredPlugin({ type, nodeUuid, value, enabled }) {
    return `<span class="${type} anchored-plugin${
        !enabled ? " half-opacity" : ""
    }" data-pluginid="ANCHORED_HEXAGON" data-type="${
        type}" data-enabled=${
        enabled} data-anchoruuid="${shortId.uuid()}" data-nodeid="${
        nodeUuid}" data-position="${
        positions[type]
    }">${value}</span>`;
}

function generateAnchoredPlugins({ nodeUuid, plugins = [] } = {}) {
    const aaa = plugins.reduce((acc, [type, value]) => acc + createAnchoredPlugin({ type, nodeUuid, value, enabled: true }), "");
    return aaa;
}

export function setAnchoredOnDiagram(diagramInstance, data) {
    if (!data.plugins.length) {
        return;
    }
    const node = diagramInstance.nodes.find(({ id }) => id === `a${data.nodeUuid}`);
    if (node) {
        node.annotations[1].template = `<div class="anchored-row">${generateAnchoredPlugins(data)}<div>`;
        diagramInstance.dataBind();
    }
}

function convertNode(node, index, diagramSettings) {
    return {
        id: `a${node.uuid}`,
        annotations: [
            {
                id: node.label.uuid,
                content: node.label.value,
                offset: {
                    x: 0.5,
                    y: 1.1
                },
                style: {
                    color: "#273858",
                    fontFamily: "Roboto",
                    fontSize: 10,
                    fill: "#F3F5F7"
                },
                verticalAlignment: "Top",
                visibility: diagramSettings.showLabels,
                constraints: AnnotationConstraints.ReadOnly
            },
            {
                template: "",
                height: 24,
                width: 0,
                visibility: true,
                verticalAlignment: "Top",
                horizontalAlignment: "Center",
                constraints: AnnotationConstraints.ReadOnly
            }
        ],
        offsetX: node.x,
        offsetY: node.y,
        data: { typeId: node.id },
        style: { strokeColor: "transparent", fill: "none" },
        outEdges: [...(node.outgoing || [])],
        inEdges: [...(node.incoming || [])],
        addInfo: { additionalOptions: { ...node.label.additionalOptions } },
        zIndex: 300 + index
    };
}

function convertConnector(connector, diagramSettings) {
    const res = {
        id: connector.uuid,
        type: "Orthogonal",
        targetPortID: ports[connector.endSide],
        sourceID: `a${connector.from}`,
        targetID: `a${connector.to}`,
        style: {
            strokeColor: "#3E71D2"
        },
        annotations: [
            {
                id: connector.label.uuid,
                content: connector.label.value,
                visibility: diagramSettings.showLabels
            }
        ],
        segments: connector.segments || [{ type: "Orthogonal" }]
    };
    return res;
}

function diagramTemplate(nodes, connectors, diagramSettings) {
    const diagram = {
        ...diagramConfig,
        constraints: diagramSettings.showBridges ? 502 : 500,
        nodes,
        connectors
    };
    if (diagramSettings.showGrid) {
        diagram.snapSettings.constraints = 15; // SnapConstraints.ShowLines | SnapConstraints.SnapToLines,
    } else {
        diagram.snapSettings.constraints = 12; // SnapConstraints.SnapToLines,
    }
    return JSON.stringify(diagram);
}

export function convertOldDiagram({ content = [], connectors = [] } = {}, diagramSettings) {
    annotationConfig.visibility = diagramSettings.showLabels;
    const nodes = content.map((el, index) => convertNode(el, index, diagramSettings));
    const connectorsArr = connectors.map(el => convertConnector(el, diagramSettings));
    return diagramTemplate(nodes, connectorsArr, diagramSettings);
}
